import client from "./client";
export const getEvents = (cId, { limit, upcoming } = {}) => {
  const params = new URLSearchParams();
  if (limit) params.set("limit", limit);
  if (upcoming) params.set("upcoming", "true");
  const query = params.toString();
  return client.get(`/communities/${cId}/events${query ? `?${query}` : ""}`);
};
export const createEvent = (cId, data) => client.post(`/communities/${cId}/events`, data);
export const updateEvent = (cId, eId, data) => client.put(`/communities/${cId}/events/${eId}`, data);
export const deleteEvent = (cId, eId) => client.delete(`/communities/${cId}/events/${eId}`);
export const getProjects = (cId, { limit } = {}) =>
  client.get(`/communities/${cId}/projects${limit ? `?limit=${limit}` : ""}`);
export const createProject = (cId, data) => client.post(`/communities/${cId}/projects`, data);
export const updateProject = (cId, pId, data) => client.put(`/communities/${cId}/projects/${pId}`, data);
export const deleteProject = (cId, pId) => client.delete(`/communities/${cId}/projects/${pId}`);
